import React from "react";
import { useTimezone } from "../TimezoneContextProvider";
import { UTC, LOCAL, getLocalTimezoneName } from "helpers/timezone";

const OPTIONS = [
  { mode: LOCAL, label: `Local (${getLocalTimezoneName()})` },
  { mode: UTC, label: "UTC" },
];

const TimezoneToggle = () => {
  const { mode, setMode } = useTimezone();

  return (
    <div className="flex items-center gap-2 text-sm" data-testid="timezone-toggle">
      <span id="timezone-toggle-label">Times shown in</span>
      <div role="group" aria-labelledby="timezone-toggle-label" className="flex">
        {OPTIONS.map(({ mode: optionMode, label }, i) => {
          const isActive = mode === optionMode;
          return (
            <button
              key={optionMode}
              type="button"
              aria-pressed={isActive}
              onClick={() => setMode(optionMode)}
              className={`border px-2 py-0.5 border-gray-400 ${
                i === 0 ? "rounded-l" : "rounded-r border-l-0"
              } ${isActive ? "bg-gray-700 text-white" : "bg-transparent"}`}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TimezoneToggle;
